import { useContext } from "react";
import { FirebaseContext } from "../../../../pages/FirebaseProvider";
import { getConfig } from "../../../../config/app";

export const useCaptchaConfig = () => {
  const { sitekey }: { sitekey: string } = getConfig("googleReCaptcha");
  const firebase = useContext(FirebaseContext);
  const somebodyIsLogged = Boolean(firebase && !firebase.auth.currentUser.isAnonymous);

  return {
    captchaSitekey: sitekey,
    withCaptcha: !somebodyIsLogged
  };
};
